export default "__VITE_ASSET__97543522__"